// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-newsletter-form-success-message__title[data-v-b6d33dda]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;margin-bottom:24px;grid-gap:8px;gap:8px}.footer-newsletter-form-success-message__description[data-v-b6d33dda]{max-width:272px}", ""]);
// Exports
module.exports = exports;
